import { IOrder } from '@/api/types/order';
import { useState } from 'react';

// 商品项接口定义，基于Vue组件中的数据结构
interface GoodsItem {
  id: number;
  shop_sku: string;
  frame_color: string;
  image_url: string;
  is_glass: number;
  short_name: string;
  prescription_type: string;
  prescription: any;
  lens_info?: any;
  prescriptions_image_url?: string;
}

// 选中商品的简化结构
interface SelectedGoods {
  id: number;
  shop_sku: string;
}

export const useGoodsSelect = () => {
  const [showGoodsSelector, setShowGoodsSelector] = useState(false);
  const [selectedGoods, setSelectedGoods] = useState<SelectedGoods[]>([]);
  const [skuList, setSkuList] = useState<GoodsItem[]>([]);
  const [loading, setLoading] = useState(false);

  // 从订单中提取商品列表
  const loadGoodsFromOrder = (order: IOrder | null) => {
    if (!order || !order.order_items) {
      setSkuList([]);
      return;
    }

    setLoading(true);
    try {
      // 将订单商品转换为商品选择器需要的格式
      const goods: GoodsItem[] = order.order_items.map((item) => ({
        id: item.id,
        shop_sku: item.shop_sku,
        frame_color: item.frame_color,
        image_url: item.image_url,
        is_glass: (item as any).is_glass || 1, // 默认为眼镜，使用类型断言
        prescription_type: item.prescription?.prescription_type || '',
        prescription_type_name: item.prescription?.prescription_type_name || '',
        prescription: item.prescription || {},
        lens_info: item.lens_info,
        short_name: item.short_name,
        prescriptions_image_url: (item as any).prescriptions_image_url || '',
      }));

      setSkuList(goods);
    } catch {
      setSkuList([]);
    } finally {
      setLoading(false);
    }
  };

  // 切换商品选择状态
  const toggleGoodsSelection = (item: GoodsItem) => {
    const isSelected = selectedGoods.some((goods) => goods.id === item.id);

    if (isSelected) {
      // 取消选择
      setSelectedGoods((prev) => prev.filter((goods) => goods.id !== item.id));
    } else {
      // 添加选择
      setSelectedGoods((prev) => [
        ...prev,
        {
          id: item.id,
          shop_sku: item.shop_sku,
        },
      ]);
    }
  };

  // 检查商品是否被选中
  const isGoodsSelected = (item: GoodsItem) => {
    return selectedGoods.some((goods) => goods.id === item.id);
  };

  // 清空选择
  const clearSelectedGoods = () => {
    setSelectedGoods([]);
  };

  // 重置所有状态
  const resetGoodsSelect = () => {
    setSelectedGoods([]);
    setSkuList([]);
    setLoading(false);
  };

  return {
    showGoodsSelector,
    setShowGoodsSelector,
    selectedGoods,
    setSelectedGoods,
    skuList,
    setSkuList,
    loading,
    loadGoodsFromOrder,
    toggleGoodsSelection,
    isGoodsSelected,
    clearSelectedGoods,
    resetGoodsSelect,
  };
};
